import styled from '@emotion/styled';
import { AnalyticsTargetLayerAreaProvider, GoogleMap, useMap } from 'rwl-ui';
import { ServiceAreaMarkers } from './Markers/ServiceAreaMarkers';
import { NeighborhoodMarkers } from './Markers/NeighborhoodMarkers';
import MapControls from './MapControls';
import { useInitializeMap } from '../../hooks/useInitializeMap';
import { useGlobal } from '../../hooks';
import { useMapEvents } from '../../hooks/useMapEvents';
import { useDisableMapControls } from '../../hooks/useDisableMapControls';
import { TargetLayerArea } from 'rwl-shared/dist/models/analytics';

const NeighborhoodMapContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const MapView = () => {
    const { map } = useMap();
    const { config } = useGlobal();
    useMapEvents();
    useInitializeMap(config);
    useDisableMapControls();

    return (
        <AnalyticsTargetLayerAreaProvider targetLayerArea={TargetLayerArea.MAP}>
            <NeighborhoodMapContainer>
                <GoogleMap>
                    {map && <MapControls map={map} />}
                    <ServiceAreaMarkers />
                    <NeighborhoodMarkers />
                </GoogleMap>
            </NeighborhoodMapContainer>
        </AnalyticsTargetLayerAreaProvider>
    );
};
